export function extractValue(val) {
  return `${val.slice(0, 2)}${val.slice(3, 10)}`;
}

export function hashedMask(ein, showFullEin = false) {
  const valueHidden = ein.replace(/[\w]/g, 'X');
  if (valueHidden.length <= 2) {
    return showFullEin ? ein : valueHidden;
  }

  if (valueHidden.length <= 10) {
    return showFullEin
      ? `${ein.slice(0, 2)}-${ein.slice(2, 10)}`
      : `${valueHidden.slice(0, 2)}-${valueHidden.slice(2, 10)}`;
  }
}

export function isPositiveInteger(str) {
  if (typeof str !== 'string') {
    return false;
  }

  const num = Number(str);

  if (Number.isInteger(num) && num >= 0) {
    return true;
  }

  return false;
}
